/**
 * This enumeration represents all possible ways of representing a group of objects in the UI
 */

export enum ViewMode {
  ListElement = 'list',
  GridElement = 'grid',
  DetailedListElement = 'detailed',
  StandalonePage = 'standalone',
  Table = 'table',
  GeospatialMap = 'geospatial-map'
}
